module.exports = __webpack_public_path__ + "static/media/tipos-cookies.918e0fe3.png";